import { types } from '../../types';

const setAuthorizeAction = (payload) => {
    return {
        type: types.auth.SET_AUTHORIZE,
        payload,
      }
}

const setAdminAction = (payload) => {
  return {
    type: types.auth.SET_ADMIN,
    payload
  }
}

export {
    setAuthorizeAction as SetAuthorizeAction,
    setAdminAction as SetAdminAction
}
